import * as React from 'react';
import { Helmet } from 'react-helmet';
import Clients from '../components/organisms/Clients';
import CompanyInfoRow from '../components/molecules/CompanyInfoRow';
import SectionHeader from '../components/organisms/SectionHeader';
import CompanyInfoTable from '../components/molecules/CompanyInfoTable';
import Awards from '../components/organisms/Awards';
import styles from './company.module.scss';

const CompanyPage = () => {
  const stakeholders = {
    officers: [
      {
        position: '代表取締役/CEO',
        name_jp: '堀 浩輝',
      },
      {
        position: '取締役/CFO',
        name_jp: '井出 翔',
      },
    ],
    investors: [
      'Genesia Venture Fund １号投資事業有限責任組合（株式会社ジェネシア・ベンチャーズ）',
      'BEENEXT1 Pte. Ltd.',
      '未来創生２号ファンド（スパークス・グループ株式会社）',
      'Eight Roads Ventures Japan',
      'Seiga Asset Management'
    ],
    getISMS: 'ISO/IEC 27001:2013',
    get getInvestors() {
      return this.investors;
    },
    get getOfficers() {
      return this.officers;
    },
  };

  return (
    <div>
      <Helmet title="会社概要 | 株式会社HRBrain" />
      <SectionHeader title_en="COMPANY" title_jp="会社概要" />
      <div className={`${styles.content} ${styles.conmanyInfo}`}>
        <CompanyInfoRow title="社名" description="株式会社HRBrain" />
        <hr />
        <CompanyInfoRow title="設立" description="2016年" />
        <hr />
        <CompanyInfoRow title="代表" description="堀浩輝" />
        <hr />
        <CompanyInfoRow
          title="所在地"
          description={`東京都品川区上大崎2-25-2 新目黒東急ビル 5F \n 大阪府大阪市北区角田町 1-12 阪急ファイブアネックスビル2F`}
        />
        <hr />
        <CompanyInfoRow
          title="主要株主"
          description={stakeholders.getInvestors.join('\n')}
        />
        <hr />
        <CompanyInfoTable
          title="役員"
          table={stakeholders.getOfficers}
        />
        <hr />
        <CompanyInfoRow
          title="取得認証"
          description={stakeholders.getISMS}
        />
      </div>
      <SectionHeader title_en="AWARD" title_jp="受賞歴" />
      <Awards />
      <SectionHeader title_en="CLIENTS" title_jp="取引先" />
      <Clients />
    </div>
  );
};

export default CompanyPage;
